import { render, staticRenderFns } from "./DialogReedition.vue?vue&type=template&id=a87d49a4&"
import script from "./DialogReedition.vue?vue&type=script&lang=ts&"
export * from "./DialogReedition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports